export default __webpack_public_path__ + "static/media/Microsoft.eca04985.png";